const bundle = {
  close: () => 'Đóng',
  error: () => 'Lỗi',
  warn: () => 'Cảnh báo',
  info: () => 'Thông tin',
  confirmation: () => 'Xác nhận',
  progressIndeterminate: () => 'Đang xử lý',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Từ ' + p['FROM_SECTION'] + ' đến ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Không tìm thấy phần nào phù hợp.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Nhấn enter để chọn giá trị.',
  indexer_touchInstructionText: () =>
    'Chạm hai lần và giữ để truy cập chế độ cử chỉ, rồi kéo lên hoặc xuống để điều chỉnh giá trị.',
  inputPassword_show: () => 'Hiển thị mật khẩu',
  inputPassword_hide: () => 'Ẩn mật khẩu',
  inputPassword_hidden: () => 'Mật khẩu bị ẩn',
  formControl_clear: () => 'Xóa',
  formControl_loading: () => 'Đang tải',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Đã vượt quá độ dài tối đa ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Còn lại ' + p['CHARACTER_COUNT'] + ' ký tự.',
  select_noMatchesFound: () => 'Không tìm thấy kết quả khớp nào.',
  select_oneMatchFound: () => 'Tìm thấy một kết quả khớp',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Tìm thấy ' + p['TOTAL_SIZE'] + ' kết quả phù hợp',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Tìm thấy ' + p['TOTAL_SIZE'] + ' kết quả phù hợp trở lên',
  selectMultiple_showSelectedValues: () => 'Chỉ hiển thị các giá trị đã chọn.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Đã chọn ' + p['VALUE_COUNT'] + ' giá trị.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Đã đánh dấu vào hộp chọn',
  selector_unselected: () => 'Chưa đánh dấu vào hộp chọn',
  userAssistance_learnMore: () => 'Tìm hiểu thêm',
  userAssistance_required: () => 'Bắt buộc',
  filePicker_singleFileUploadError: () => 'Tải lên một tập tin tại một thời điểm',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Bạn không thể tải lên tập tin loại ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Bạn không thể tải lên tập tin loại: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'không xác định',
  filePicker_dropzonePrimaryText: () => 'Kéo và thả',
  filePicker_dropzoneSecondaryText: () => 'Chọn tập tin hoặc thả một tập tin vào đây',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Chọn hoặc thả tập tin ở đây',
  filePicker_addFiles: () => 'Thêm tập tin',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Tăng',
  inputNumber_decrease: () => 'Giảm',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Không có mục nào để hiển thị',
  message_navigationFromMessagesRegion: () =>
    'Truy cập khu vực thông báo. Nhấn F6 để chuyển trở lại yếu tố được làm nổi bật trước.',
  message_navigationToMessagesRegion: () =>
    'Có thông báo mới ở khu vực thông báo. Hãy nhấn F6 để chuyển đến khu vực thông báo gần đây nhất.',
  messageToast_allMessagesClosed: () => 'Tất cả thông báo bật lên đều được đóng.'
};
export default bundle;
